export default {
    buttons: {
        back: "Zadní",
        next: "další",
        submit: "Předložit"
    }
}